import AccountSecurityIcon from './AccountSecurityIcon/AccountSecurityIcon';
import ExploreRealEstateIcon from './ExploreRealEstateIcon/ExploreRealEstateIcon';
import InfoIcon from './InfoIcon/InfoIcon';
import LogoutIcon from './LogoutIcon/LogoutIcon';

import PencilIcon from './PencilIcon/PencilIcon';
import PrivacyPolicyIcon from './PrivacyPolicyIcon/PrivacyPolicyIcon';
import ProfileIcon from './ProfileEditIcon/ProfileIcon';
import ProfileSettingsIcon from './ProfileSettingsIcon/ProfileSettingsIcon';
import RealTimeBetsIcon from './RealTimeBetsIcon/RealTimeBetsIcon';
import ResponsibleGamblingIcon from './ResponsibleGamblingIcon/ResponsibleGamblingIcon';
import SelectedAvatarIcon from './SelectedAvatarIcon/SelectedAvatarIcon';
import TermsAndConditionsIcon from './TermsAndConditionsIcon/TermsAndConditionsIcon';
import TransactionsIcon from './TransactionsIcon/TransactionsIcon';
import VerificationIcon from './VerificationIcon/VerificationIcon';
import WageredAmountIcon from './WageredAmountIcon/WageredAmountIcon';
import XpStatIcon from './XpStatIcon/XpStatIcon';
import EmailIcon from './EmailIcon/EmailIcon';
import CompletedIcon from './CompletedIcon/CompletedIcon';
import PendingIcon from './PendingIcon/PendingIcon';
import BugIcon from './BugIcon/BugIcon';
import ChevronArrowIcon from './ChevronArrowIcon/ChevronArrowIcon';
import InformationIcon from './InformationIcon/InformationIcon';
import FailedIcon from './FailedIcon/FailedIcon';
import SpyHiddenIcon from './SpyHiddenIcon/SpyHiddenIcon';
import SearchIcon from './SearchIcon/SearchIcon';

export const generalIcons: GeneralIconsInterface = {
	pencil: PencilIcon,
	profilesettings: ProfileSettingsIcon,
	profile: ProfileIcon,
	transactions: TransactionsIcon,
	logout: LogoutIcon,
	verification: VerificationIcon,
	responsiblegambling: ResponsibleGamblingIcon,
	selectedavatar: SelectedAvatarIcon,
	termsandconditions: TermsAndConditionsIcon,
	privacypolicy: PrivacyPolicyIcon,
	info: InfoIcon,
	information: InformationIcon,
	realtimebets: RealTimeBetsIcon,
	accountsecurity: AccountSecurityIcon,
	xpstat: XpStatIcon,
	wageredamount: WageredAmountIcon,
	email: EmailIcon,
	explorerealestate: ExploreRealEstateIcon,
	completed: CompletedIcon,
	pending: PendingIcon,
	failed: FailedIcon,
	bug: BugIcon,
	chevronarrow: ChevronArrowIcon,
	spyhidden: SpyHiddenIcon,
	searchicon: SearchIcon,
};

export interface GeneralIconsInterface {
	pencil: React.FC<React.SVGProps<SVGSVGElement>>;
	profilesettings: React.FC<React.SVGProps<SVGSVGElement>>;
	profile: React.FC<React.SVGProps<SVGSVGElement>>;
	transactions: React.FC<React.SVGProps<SVGSVGElement>>;
	logout: React.FC<React.SVGProps<SVGSVGElement>>;
	verification: React.FC<React.SVGProps<SVGSVGElement>>;
	responsiblegambling: React.FC<React.SVGProps<SVGSVGElement>>;
	selectedavatar: React.FC<React.SVGProps<SVGSVGElement>>;
	termsandconditions: React.FC<React.SVGProps<SVGSVGElement>>;
	privacypolicy: React.FC<React.SVGProps<SVGSVGElement>>;
	info: React.FC<React.SVGProps<SVGSVGElement>>;
	information: React.FC<React.SVGProps<SVGSVGElement>>;
	realtimebets: React.FC<React.SVGProps<SVGSVGElement>>;
	accountsecurity: React.FC<React.SVGProps<SVGSVGElement>>;
	xpstat: React.FC<React.SVGProps<SVGSVGElement>>;
	wageredamount: React.FC<React.SVGProps<SVGSVGElement>>;
	email: React.FC<React.SVGProps<SVGSVGElement>>;
	explorerealestate: React.FC<React.SVGProps<SVGSVGElement>>;
	completed: React.FC<React.SVGProps<SVGSVGElement>>;
	pending: React.FC<React.SVGProps<SVGSVGElement>>;
	failed: React.FC<React.SVGProps<SVGSVGElement>>;
	bug: React.FC<React.SVGProps<SVGSVGElement>>;
	chevronarrow: React.FC<React.SVGProps<SVGSVGElement>>;
	spyhidden: React.FC<React.SVGProps<SVGSVGElement>>;
	searchicon: React.FC<React.SVGProps<SVGSVGElement>>;
}
